import T from 'prop-types'
import { useCounterUp } from '../hooks'

function LoadingDots({ delay, length, children }) {
  const count = useCounterUp(delay, length)

  return <div className="w-[75px]">{children + '.'.repeat(count)}&nbsp;</div>
}

LoadingDots.propTypes = {
  delay: T.number,
  length: T.number,
  children: T.string.isRequired,
}

export default LoadingDots
